import type { Template } from '@enmon/commons/lib/tools';
import type { UploadFile } from 'antd';
import { useServices } from 'containers/services';
import { useMutation, type UseMutationResult } from 'react-query';
import { notifyError, notifySuccess } from 'utils/notifications';
import { MUTATION_KEYS } from 'utils/queryKeys';

export const useUploadTemplate = (onSuccess: () => void): UseMutationResult<{ status: 'OK' }, unknown, UploadFile> => {
  const { templatesApiClient } = useServices();

  return useMutation((file: UploadFile) => templatesApiClient.upload(file), {
    mutationKey: MUTATION_KEYS.templates.uploadTemplate(),
    onError: error => {
      if (error instanceof Error) {
        notifyError(error, {
          message: 'There was an error while uploading template',
        });
      }
    },
    onSuccess: () => {
      notifySuccess({
        message: `Template uploaded`,
      });
      onSuccess();
    },
  });
};

export const useDeleteTemplate = (onSuccess: () => void): UseMutationResult<void> => {
  const { templatesApiClient } = useServices();
  return useMutation((id: Template['id']) => templatesApiClient.delete(id), {
    onError: error => {
      if (error instanceof Error) {
        notifyError(error, {
          message: 'There was an error while deleting template',
        });
      }
    },
    onSuccess: () => {
      notifySuccess({
        message: `Template deleted`,
      });
      onSuccess();
    },
  });
};
